import { useEffect } from 'react';

import { obtainBadge } from '../../../common/badge';
import { LS_APRIL_FOOL } from '../../../config';

import * as style from './style.module.css';

let joke = Math.floor(Math.random() * Object.keys(style).filter((name) => /^joke-/.test(name)).length) + 1;

const isAprilFoolDay = () => {
    const now = new Date();
    return now.getDate() === 1 && now.getMonth() === 3;
};

const Fun = () => {
    useEffect(() => {
        const evt = setInterval(async () => {
            // April fools
            if (isAprilFoolDay()) {
                obtainBadge('a917d55b-46b3-4065-9b75-4f8ce7c02b8a');
            }
        }, 15000);
        return () => clearInterval(evt);
    }, []);

    // Not april fool day
    if (!isAprilFoolDay()) {
        return null;
    }

    // April fools is disabled manually
    if (!localStorage.getItem(LS_APRIL_FOOL)) {
        // Class not already set
        if (![...document.documentElement.classList].some(cn => cn === style[`joke-${joke}`])) {
            console.log(`🎣 Joke #${joke}`);

            // Remove all joke classes
            document.documentElement.classList.forEach(e => {
                for (const className of Object.keys(style)) {
                    if (e === style[className]) {
                        document.documentElement.classList.remove(e);
                        break;
                    }
                }
            })

            // Set joke class
            document.documentElement.classList.add(style[`joke-${joke}`]);
        }
    } else {
        console.log('🍣 No fun allowed');
    }

    return null;
};

export default Fun;
